export const getUsersVehicleProfile = (client, userId, vehicleId, revisionId) => client.rpc('service-vehicle-profile', '1/2020-11-13/get_users_vehicle_profile', {
    userId,
    vehicleId,
    revisionId,
});
export const getVehicleProfile = (client, request) => client.rpc('service-vehicle-profile', '1/2019-10-23/get_vehicle_profile', request);
export const listVehicleProfiles = (client, request) => client.rpc('service-vehicle-profile', '1/2019-10-23/list_vehicle_profiles', request);
export const updateVehicleProfile = (client, request) => client.rpc('service-vehicle-profile', '1/2019-10-23/update_vehicle_profile', request);
export const createVehicleProfile = (client, request) => client.rpc('service-vehicle-profile', '1/2024-01-23/create_vehicle_profile', request);
